<template>
  <AppHeader/>
  <RouterView/>
  <AppNavigation/>
  <AppModalSelector/>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppNavigation from '@/components/AppNavigation'
import AppModalSelector from '@/components/AppModalSelector'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppNavigation,
    AppModalSelector,
  },
  data() {
    return {
      loading: true,
      logoImage: require('@/assets/logo.svg'),
    }
  },
  methods: {
  },
  created() {
    document.title = 'sleep&me';
  },
}
</script>